import type { ReactNode } from "react";
import { t } from "@/i18n-js/instance";
import { PageMetaData } from "@/react/components/Layout/PageMetaData";
import { useIsConnectEnabled } from "@/react/hooks/useIsConnectEnabled";
import { useNavigationLinks } from "@circle-react-uikit/HeaderV3/NavigationBar/hooks/useNavigationLinks";
import { AudienceSearchContext } from "../shared/MemberFilters/AudienceSearchContext";
import { LeftSideProfileNavigation } from "./shared/LeftSideProfileNavigation";
import { MobileNavigationTabs } from "./shared/MobileNavigationTabs";

const bodyClassNames = "view-members-directory";

interface MemberDirectoryLayoutV2Props {
  children: ReactNode;
}

export const MemberDirectoryLayoutV2 = ({
  children,
}: MemberDirectoryLayoutV2Props) => {
  const { memberDirectoryLink } = useNavigationLinks();

  const isConnectEnabled = useIsConnectEnabled();

  const memberDirectoryTitle =
    memberDirectoryLink?.label || t("members_directory.title");

  return (
    <AudienceSearchContext.Provider value={{ usage: "contacts" }}>
      <div className="main bg-primary h-full">
        <PageMetaData
          title={memberDirectoryTitle}
          bodyClassNames={bodyClassNames}
        />

        {isConnectEnabled && <MobileNavigationTabs />}

        <div className="h-full sm:mx-6 md:pt-6 lg:mx-9">
          <div className="mx-auto flex max-w-6xl flex-col gap-4 md:flex-row md:gap-8">
            <div className="hidden md:flex">
              <LeftSideProfileNavigation />
            </div>
            <div className="min-w-0 flex-1 overflow-x-auto">
              <div className="w-full md:min-w-[772px]">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </AudienceSearchContext.Provider>
  );
};
